module.exports = __webpack_public_path__ + "static/media/HitATune.83a8186e.png";